const ISO3166Subdivision = /^[A-Z][A-Z][A-Z]?$/

/**
 * @typedef {string} ISO3166Subdivision
 *
 * {@link https://en.wikipedia.org/wiki/ISO_3166}
 */
function createIsoSubdivisionPropType(isRequired) {
    // The factory returns a custom prop type
    return function (props, propName, componentName) {
        const prop = props[propName]

        if (prop === undefined) {
            // Prop is missing
            if (isRequired) {
                // Prop is required but wasn't specified. Throw an error.
                return new Error(`Property '${propName}' is marked as required at '${componentName}' but was omitted`)
            }
            // Prop is optional. Do nothing.
        } else if (prop && !ISO3166Subdivision.test(prop)) {
            return new Error(
                `Invalid ISO3166Subdivision property '${propName}' supplied to '${componentName}': ${prop}`
            )
        }
    }
}

// Using the factory, create two different versions of your prop type
export const iso3166SubdivisionPropType = createIsoSubdivisionPropType(false)
iso3166SubdivisionPropType.isRequired = createIsoSubdivisionPropType(true)
